<template>
  <div class="grid grid-cols-5 col-span-5 pt-2 pb-2 pl-4 pr-4">
    <div class="col-span-5 text-sm text-gray-dark bg-gray-lightest rounded-lg p-3">
      <div class="flex justify-between items-center">
        <span class="font-semibold">{{ data.stage }}</span>
        <span v-if="data.decision" class="text-xs text-gray-medium">{{ data.decision }}</span>
      </div>
      <BaseCollapse :items="items" class="mt-2" />
    </div>
  </div>
</template>

<script>
import BaseCollapse from '@/components/base-components/BaseCollapse.vue'

export default {
  name: 'ConversationDebugStep',

  components: { BaseCollapse },

  props: {
    message: {
      type: Object,
      required: true
    }
  },

  computed: {
    data() {
      return this.message.data || {}
    },

    items() {
      const items = []
      if (this.data.input) items.push({ label: 'Input', value: JSON.stringify(this.data.input, null, 2) })
      if (this.data.output) items.push({ label: 'Output', value: JSON.stringify(this.data.output, null, 2) })
      if (this.data.meta) items.push({ label: 'Meta', value: JSON.stringify(this.data.meta, null, 2) })
      return items
    }
  }
}
</script>
